import {
  Table as MuiTable,
  TableBody as MuiTableBody,
  type TableBodyProps as MuiTableBodyProps,
  TableCell as MuiTableCell,
  type TableCellProps as MuiTableCellProps,
  TableContainer as MuiTableContainer,
  type TableContainerProps as MuiTableContainerProps,
  TableFooter as MuiTableFooter,
  type TableFooterProps as MuiTableFooterProps,
  TableHead as MuiTableHead,
  type TableHeadProps as MuiTableHeadProps,
  TablePagination as MuiTablePagination,
  type TablePaginationProps as MuiTablePaginationProps,
  type TableProps as MuiTableProps,
  TableRow as MuiTableRow,
  type TableRowProps as MuiTableRowProps,
  TableSortLabel as MuiTableSortLabel,
  type TableSortLabelProps as MuiTableSortLabelProps
} from "@mui/material";

export type TableProps = MuiTableProps;
export type TableBodyProps = MuiTableBodyProps;
export type TableCellProps = MuiTableCellProps;
export type TableContainerProps = MuiTableContainerProps;
export type TableHeadProps = MuiTableHeadProps;
export type TableRowProps = MuiTableRowProps;
export type TableFooterProps = MuiTableFooterProps;
export type TablePaginationProps = MuiTablePaginationProps;
export type TableSortLabelProps = MuiTableSortLabelProps;

export const Table = MuiTable;
export const TableBody = MuiTableBody;
export const TableCell = MuiTableCell;
export const TableContainer = MuiTableContainer;
export const TableHead = MuiTableHead;
export const TableRow = MuiTableRow;
export const TableFooter = MuiTableFooter;
export const TablePagination = MuiTablePagination;
export const TableSortLabel = MuiTableSortLabel;
